module.exports = __webpack_public_path__ + "static/media/tramites.73d3310a.svg";